import { render, staticRenderFns } from "./ScientificPublications.vue?vue&type=template&id=18e773c9&scoped=true&"
import script from "./ScientificPublications.vue?vue&type=script&lang=js&"
export * from "./ScientificPublications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e773c9",
  null
  
)

export default component.exports